// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f960b3b3","262":"662e3b77","549":"977ce019"}[chunkId] + ".chunk.js";
};